export default "__VITE_ASSET__c47fbae8__"